import { Routes, Route } from 'react-router-dom';
import ManageAlerts from './components/alert/ManageAlerts';
import AlertClientInfo from './components/alert/AlertClientInfo';
import AlertRepository from './components/alert/AlertRepository';
function AppAlerts() {
    return (
        <Routes>
            <Route path="createalert" element={<ManageAlerts />} />
			<Route path="alertclient" element={<AlertClientInfo />} />repository
			<Route path="repository" element={<AlertRepository />} />
        </Routes>
    );
}

export default AppAlerts;